import type { MouseEvent } from 'react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import type { OpenQuoteWithSubTopic } from '../../../../types';
import { isPlainLeftClick } from '../../../../utils/isPlainLeftClick';
import { toPendingQuoteRow } from '../../utils/pendingQuoteRow';

type Props = {
  quote: OpenQuoteWithSubTopic;
};

export function useOpenQuoteItem(props: Props) {
  const spacePath = useSpacePath();
  const navigate = useNavigate();

  const targetUrl = spacePath(`/topics/${props.quote.sub_topics.id}`);
  // Across the space, the sub-topic tells the rows apart.
  const row = useMemo(() => toPendingQuoteRow(props.quote, props.quote.sub_topics.name), [props.quote]);

  function handleClick(event: MouseEvent<HTMLElement>) {
    if (!isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    navigate(targetUrl);
  }

  return {
    row,
    targetUrl,
    handleClick,
  };
}
